import { useState } from 'react';

import {
  PayerOrganizationRead,
  usePayersListQuery,
} from 'src/common/external/bambi-api/bambiApi';
import { ItemSelector } from 'src/common/ItemSelector/ItemSelector';

export function PayersFilter({
  selectedPayers,
  onPayerChange,
}: {
  selectedPayers: PayerOrganizationRead[];
  onPayerChange: (payers: PayerOrganizationRead[]) => void;
}) {
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  const {
    data: payers,
    isLoading: payersLoading,
    isFetching: payersFetching,
  } = usePayersListQuery({
    search: debouncedSearchTerm,
  });

  return (
    <ItemSelector
      items={payers?.results || []}
      selectedItems={selectedPayers}
      loading={payersLoading}
      searching={payersFetching}
      onSelectionChange={onPayerChange}
      onSearchChange={setDebouncedSearchTerm}
      searchPlaceholder="Search payers"
      getItemLabel={(payer) => payer.display_name}
      dataTestId="payers-filter-search"
      noItemsText="No payers found."
    />
  );
}
